import { Injectable } from '@angular/core';
import { ApiService } from 'app/modules/common/services/api.service';
import { SharedService } from 'app/modules/common/services/shared-service';
import { EmployeeService } from './employee.service';

@Injectable({providedIn:'root'})

export class EmployeeStoreService {

    constructor(
        public employeeService: EmployeeService,
        private apiService: ApiService,
        public sharedService: SharedService) {
        this.initEmployee();
    }

    public employee: any = '';

    setEmployeeHeaderData(): void {
        this.employee = {
            apellidos: this.employeeService.currentEmployee.apellidos,
            nombre: this.employeeService.currentEmployee.nombre,
            telefono1: this.employeeService.currentEmployee.telefono1,
            telefono2: this.employeeService.currentEmployee.telefono2,
            movil: this.employeeService.currentEmployee.movil,
            telefono4: this.employeeService.currentEmployee.telefono4,
            importacionId: this.employeeService.currentEmployee.importacionId,
            telCancelado:this.employeeService.currentEmployee.telCancelado
        };
    }

    initEmployee(): void {
        const Emplooyeeid = localStorage.getItem('EmplooyeeID');
        if (Emplooyeeid != "-1") {
            this.employeeService.getheaderDetails(Emplooyeeid).subscribe(_res => {
                const data = localStorage.getItem('EmplooyeeData');
                if (data.charAt(0) === '[') {
                    this.employeeService.currentEmployee = JSON.parse(data[0]);
                }
                if (data.charAt(0) === '{') {
                    this.employeeService.currentEmployee = JSON.parse(data);
                }
                this.setEmployeeHeaderData();
                this.sharedService.setCurrentEmployeeName(`${(this.employeeService.currentEmployee).apellidos}, ${(this.employeeService.currentEmployee).nombre}`);
            });
        }
    }


    /**
       * Purpose is to refresh the entire employee view
       * @param employeeId This ID will be used to update all views
       */
    public updateAllEmployeeViews(employeeId: number) {
        // purpose is to refresh the entire employee view. problem, there is no better way.
        // everyone develop this part use their own way to refresh views. So I am putting all of them
        // together here
        this.employeeService.saveemplooye.emit(employeeId);
        this.employeeService.getTrabajador(employeeId);
        this.initEmployee();
    }

}
